import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useIsBreakpoint } from '@/hooks/use-is-breakpoint';
import { EllipsisVertical } from 'lucide-react';
import type { ReactNode } from 'react';

export function GlobalTopBarActions({ children }: { children: ReactNode }) {
    const isXlUp = useIsBreakpoint('min', 1280);

    if (isXlUp) {
        return <div className="flex items-center gap-2">{children}</div>;
    }

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    type="button"
                    size="sm"
                    variant="outline"
                    className="border-none"
                >
                    <EllipsisVertical className="h-4 w-4" />
                </Button>
            </PopoverTrigger>
            <PopoverContent
                align="end"
                className="flex flex-col w-auto gap-2 p-2 [&_button]:cursor-pointer"
            >
                {children}
            </PopoverContent>
        </Popover>
    );
}
